module.exports = require("./../../_gen/starling/utils/RectangleUtil");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/utils/RectangleUtil.js
// module id = 252
// module chunks = 0